import styled from 'styled-components';
import { getKeyboardShortcutArray } from '@frameio/shared/commands/utils/getKeyboardShortcutString';
import { Button2 as Button, Shortcut, useIsAppleOs } from '@frameio/vapor';
import { theme } from '@frameio/vapor-theme';
import { useNavigateToAdvancedSearch } from '../../../hooks';
import TEXT from './generated/TEXT/QuickSearchResultsFooter';
import styles from './QuickSearchResultsFooter.module.css';

TEXT.DEFINE({
  /** Label for redirect to advanced search */
  buttonLabel: 'See all results',
});

const FooterShortcut = styled(Shortcut)`
  color: ${theme.colors.text.secondary};
  height: ${theme.spaces[20]};
  min-width: ${theme.spaces[20]};
`;

type QuickSearchResultsFooterProps = {
  inline?: boolean;
};

export const QuickSearchResultsFooter = ({
  inline = false,
}: QuickSearchResultsFooterProps) => {
  const navigateToAdvancedSearch = useNavigateToAdvancedSearch();
  const isAppleOs = useIsAppleOs();
  const button = (
    <Button onPress={() => navigateToAdvancedSearch({})} variant="tertiary">
      <div className={styles.buttonContent}>
        <span className={styles.buttonLabel}>{TEXT.buttonLabel}</span>
        <div className={styles.shortcutContainer}>
          {getKeyboardShortcutArray(['Meta', 'Shift', 'Enter'], isAppleOs).map(
            (key) => (
              <FooterShortcut key={key} type="neverBeenUsed">
                {key}
              </FooterShortcut>
            )
          )}
        </div>
      </div>
    </Button>
  );

  if (inline) {
    return button;
  }

  return <div className={styles.footer}>{button}</div>;
};
